import React from 'react';

import { Typography } from '@mui/material';
import { GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid-pro';

export default function CharterFlightsPricingToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
      <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
        Filters and sorting apply to this departure page only.
      </Typography>
    </GridToolbarContainer>
  );
}
